import { ComponentType } from 'react';
import { IconProps } from '@velocity-exchange/icons';
import { cm } from 'src/utils/classNames';
import { WithChildren } from 'src/utils/UtilityTypes';

export type TagVariant = 'neutral' | 'subtle' | 'warning' | 'danger';

const VARIANT_CLASSNAMES: Record<TagVariant, string> = {
	neutral: 'bg-button-secondary-bg text-text-default',
	subtle: 'bg-button-selector text-text-default',
	warning: 'bg-warn-orange-secondary-bg text-star-yellow',
	danger: 'bg-negative-red-secondary-bg text-negative-red',
};

export interface TagProps extends WithChildren {
	/**
	 * Semantic color preset. Omit if you need a one-off color via `className`.
	 */
	variant?: TagVariant;
	/**
	 * Extends or overrides the variant's styles. Required if `variant` is not set.
	 */
	className?: string;
	leftIcon?: ComponentType<IconProps>;
	rightIcon?: ComponentType<IconProps>;
}

export default function Tag({
	variant,
	className,
	children,
	leftIcon: LeftIcon,
	rightIcon: RightIcon,
}: TagProps) {
	return (
		<div
			className={cm(
				'flex items-center gap-x-2xs rounded-xs px-xs py-2xs typo-body-2xs',
				variant && VARIANT_CLASSNAMES[variant],
				className
			)}
		>
			{LeftIcon && <LeftIcon size={12} />}
			{children}
			{RightIcon && <RightIcon size={12} />}
		</div>
	);
}
